import { useTheme } from "@mui/material";

export type PaletteColor = "primary" | "secondary" | "error" | "warning" | "info" | "success" | "default";

export const useThemePaletteColor = (color: PaletteColor): string => {
    const theme = useTheme();

    return color === "default" ? theme.palette.text.primary : theme.palette[color].main;
};
